module.exports = __webpack_public_path__ + "static/media/calendarPurple.b05a548e.svg";